import React from 'react';
import PropTypes from 'prop-types';
import Loader from 'relements/build/esm/ui/loader';
import Icon from 'relements/build/esm/ui/icon';
import styles from './ContentRow.scss';

const STATUS = {
  NOT_STARTED: 0,
  STARTED: 1,
  SUCCESS: 2,
  FAIL: 3,
};

const ContentRow = ({ children, status, started }) => {
  const loading = status === STATUS.STARTED;
  const done = status === STATUS.SUCCESS;
  const fail = status === STATUS.FAIL;
  const loadingClassName = loading ? styles.loading : '';
  const doneClassName = done ? styles.done : '';
  const failClassName = fail ? styles.fail : '';
  const startedClassName = started ? styles.started : '';
  return (
    <div className={styles.contentRow}>
      <div
        className={`${
          styles.contentRowLoader
        } ${loadingClassName} ${doneClassName} ${failClassName} ${startedClassName}`}
      >
        {loading ? (
          <div className={styles.loadingWrapper}>
            <Loader className={styles.contentRowLoaderIcon} />
          </div>
        ) : null}
        {done ? (
          <Icon
            src="tick-green"
            className={styles.contentRowLoaderSuccess}
          />
        ) : null}
        {fail ? (
          <Icon
            src="error_response"
            className={styles.contentRowLoaderSuccess}
          />
        ) : null}
      </div>
      <div className={styles.contentRowText}>{children}</div>
    </div>
  );
};

ContentRow.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool,
  done: PropTypes.bool,
};

ContentRow.defaultProps = {
  children: null,
  loading: false,
  done: false,
};

export default ContentRow;
